// [2026-08-07] ADDED — entry point.
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// [2026-09-02] CHANGED — the CUSTOMER build now boots the SSO shell (PlatformApp), not the
// email/password App. The customer signs in through their existing InCruiter account; there is no
// password form here any more. App.jsx is NOT removed — proctoring-frontend-admin still imports it
// for the staff door — it is just no longer the entry for THIS build.
// OLD: import App from './App.jsx'
import PlatformApp from './PlatformApp.jsx'
import AcceptInvite from './components/AcceptInvite.jsx'
import './theme.css'
// [2026-08-11] ADDED — Tailwind utilities + shadcn tokens for the sign-in screen.
// IMPORTED AFTER theme.css ON PURPOSE: shadcn.css reads theme.css's variables (--page, --ink,
// --series-1) to map shadcn's token names onto the palette that is already validated for contrast
// and colour-blind separation. It does NOT import Tailwind's preflight reset — see the file header
// for why that would restyle all eight existing screens.
import './shadcn.css'
// [2026-09-04] ADDED — the revamped customer shell's stylesheet (IncProctor Figma).
//
// IMPORTED LAST, AND ONLY HERE. Last, because a handful of its rules deliberately outrank
// theme.css's unlayered element selectors (see the note on `.pf-search input` in that file). Only
// here, because proctoring-frontend-admin's entry imports theme.css and shadcn.css from this
// package but NOT this file — the staff dashboard keeps its current appearance, and no rule below
// can reach it. Everything in it is scoped under `.pf-app` as a second line of defence.
import './platform-theme.css'
// [2026-08-12] ADDED — accept a sign-in handed over from InCruiter. See embed.js.
// [2026-09-02] The handoff-code exchange belonged to the OLD password login (it minted a pg.session
// Bearer). SSO does not use it — the account cookie IS the session — so the customer entry no longer
// gates the render on it. embed.js is kept for the admin/legacy path.
// OLD: import { redeemHandoff } from './embed.js'

// [2026-08-12] CHANGED — the render is now gated on the handoff exchange.
//
// OLD:
//   createRoot(document.getElementById('root')).render(
//     <StrictMode>
//       <App />
//     </StrictMode>,
//   )
//
// WHY IT HAD TO CHANGE: App's boot effect reads getToken() (App.jsx:119-124) as soon as it mounts.
// Redeeming a handoff code is a network round trip, so rendering first would show the sign-in
// screen and then have a session appear underneath it — a visible flash of "please log in" for a
// user who just came from InCruiter already authenticated.
//
// Waiting is cheap and bounded: redeemHandoff() returns immediately when there is no code in the
// URL, which is every direct visit and every existing test. It never rejects, so `.finally` is
// enough and a failed exchange still renders the app — showing the normal sign-in screen, which is
// the correct fallback.
// [2026-09-02] CHANGED — render the SSO customer shell directly. No handoff exchange to wait on.
// OLD:
//   redeemHandoff().finally(() => {
//     createRoot(document.getElementById('root')).render(
//       <StrictMode>
//         <App />
//       </StrictMode>,
//     )
//   })
// [2026-09-03] ADDED — the invitation link opens /accept-invite, which must render INSTEAD of the
// dashboard, not inside it.
//
// THE REASON IS NOT COSMETIC. PlatformApp calls GET /me as it mounts. The person following an
// invitation is BY DEFINITION not a member yet, so that call answers 403 NOT_A_MEMBER and the shell
// shows "you do not have access" — over the top of the page whose entire job is to grant them
// access. Mounting the accept page first avoids that call completely.
//
// Matched on pathname rather than a router because this app has no router; the nav is a `view`
// state variable. Adding one for a single page would be a larger change than the feature.
const isAcceptInvite = window.location.pathname.replace(/\/+$/, '') === '/accept-invite'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {isAcceptInvite
      // After a successful accept the person IS a member, so sending them to / lets the shell load
      // normally. A full navigation, not a state flip: it re-runs the session bootstrap from
      // scratch rather than reusing a client that was created while they had no access.
      ? <AcceptInvite onDone={() => { window.location.href = '/' }} />
      : <PlatformApp />}
  </StrictMode>,
)
